import { Outlet } from 'react-router-dom';

import { GlobalUI } from '../GlobalUI';
import { BangCanhBaoLicense } from '../../modules/license-cuc-bo/components/BangCanhBaoLicense';
import { BangTamNgungToChuc } from './BangTamNgungToChuc';
import { PageTransition } from './PageTransition';
import { PermissionGuard } from './PermissionGuard';
import { PhamViGuard } from './PhamViGuard';
import { DongBoNhanDien } from './DongBoNhanDien';
import { Sidebar } from './Sidebar';

/**
 * Khung của nhóm route `(main)` (§3.3, §4.1).
 *
 * Hình học quan trọng: khung là `h-screen overflow-hidden` — **trang không bao
 * giờ cuộn, chỉ `<main>` cuộn**. Nhờ vậy thanh điều hướng luôn hiện đủ và không
 * trôi theo nội dung. Để cả trang cuộn là làm hỏng thanh cố định (§18.3 mục 6).
 *
 * Canvas là `bg-subtle` (**không** phải `bg-page`) ở cả khung và `<main>`; thẻ
 * mới là `bg-surface`. Ở nền sáng, canvas `#F1F5F9` và thẻ `#FFFFFF` — chính
 * quan hệ thẻ-trên-canvas này làm bố cục bento đọc được (§18.3 mục 3).
 */
export function MainLayout() {
  return (
    <div className="app-shell flex h-screen overflow-hidden bg-subtle transition-colors duration-200">
      <DongBoNhanDien />
      <Sidebar />
      {/* relative: phần tử định vị tuyệt đối bên trong (sr-only…) bám vùng cuộn này, không kéo dài cả trang */}
      <main className="relative flex-1 overflow-y-auto bg-subtle">
        <BangTamNgungToChuc />
        {/* Bản on-premise: EXPIRING, GRACE, READ_ONLY, INVALID (ADR-0058 mục 6.3) */}
        <BangCanhBaoLicense />
        {/* Phạm vi trước, quyền sau: sai cổng là lý do mạnh hơn và cần một
            câu trả lời khác hẳn "không đủ quyền". Xem `PhamViGuard`. */}
        <PhamViGuard>
          <PermissionGuard>
            <PageTransition>
              <Outlet />
            </PageTransition>
          </PermissionGuard>
        </PhamViGuard>
      </main>
      <GlobalUI />
    </div>
  );
}
